import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";
import SpecializedServiceLayout from "../shared/SpecializedServiceLayout";
import specializedFreshImg from "../../../../assets/imgs/services/international/specialized-fresh.jpg";
import { getMoreInfoItems } from "../shared/specializedMoreInfoHelpers";

function SpecializedFresh() {
  const [t] = useTranslation("specializedFreshPage");
  const [tSMetaData] = useTranslation("metaData");
  const idSpecializedFresh = "1bbc1e07-50f9-4019-acb4-7f2023410d7b";
  const [textDescription, setTextDescription] = useState("");
  const [accordion1, setAccordion1] = useState("");
  const [accordion2, setAccordion2] = useState("");
  const [accordion3, setAccordion3] = useState("");

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[1]
    }/${Object.keys(navBarEs["especializado-submenu"])[3]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[1]
    }/${Object.keys(navBarEn["specialized-submenu"])[3]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idSpecializedFresh}`)
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion1(
            response.data.textWeb.text_es["02-Restricciones y Regulaciones"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
          setAccordion3(
            response.data.textWeb.text_es["04-Manejo Especial"].content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion1(
            response.data.textWeb.text_us["02-Restrictions and Regulations"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_us[
              "03-Acceptance, Documentation and Pickup"
            ].content
          );
          setAccordion3(
            response.data.textWeb.text_us["04-Special Handling"].content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <SpecializedServiceLayout
      metaTitle={tSMetaData("specializedFresh.title")}
      metaDescription={tSMetaData("specializedFresh.description")}
      imgBackground={specializedFreshImg}
      pageTitle={t("header.title")}
      descriptionApiString={textDescription}
      descriptionFallbackJson={t("description.content")}
      quoteBtn={t("header.quote-btn")}
      quoteProductID="btnQuoteSpecializedFresh"
      contactSales={t("header.contact-sales")}
      contactProductID="btnContactSpecializedFresh"
      prepareChargeTitle={t("header.prepare-charge")}
      accordionConfigs={[
        {
          id: 1,
          title: t("accordion-1.title"),
          apiContent: accordion1,
          fallbackContentJson: t("accordion-1.content"),
        },
        {
          id: 2,
          title: t("accordion-2.title"),
          apiContent: accordion2,
          fallbackContentJson: t("accordion-2.content"),
        },
        {
          id: 3,
          title: t("accordion-3.title"),
          apiContent: accordion3,
          fallbackContentJson: t("accordion-3.content"),
        },
      ]}
      moreInfoLeft={{
        title: t("non-applicable-charges.title"),
        items: getMoreInfoItems(t, "non-applicable-charges"),
      }}
      moreInfoRight={{
        title: t("additional-conditions.title"),
        items: getMoreInfoItems(t, "additional-conditions"),
      }}
    />
  );
}

export default SpecializedFresh;
